import PropTypes from 'prop-types';

import { Link, Point } from '../header/header.types';
import UniversalLinkContainer from '../UniversalLink';
import Nullable from '../../../../../shared/nullable';
import { pointPropTypes } from '../../../common/point.propTypes';
import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import { default as styles } from '../../../scss/components/Card.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface CardLinksProps {
  points?: Point[];
  index?: number;
  isPointCarousel?: boolean;
  links?: Link[];
  type?: string;
  shouldRenderAsLink?: Nullable<boolean>;
  isHero?: boolean;
}

const CardLinks = ({
  index,
  isPointCarousel,
  links,
  type,
  shouldRenderAsLink,
  isHero,
  points = [],
}: CardLinksProps) => {
  const [link] = (isPointCarousel ? points[index || 0]?.links : links) || [];

  return link && !shouldRenderAsLink ? (
    <UniversalLinkContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...link}
      location={type}
      linkType={isHero ? 'Hero' : link.type}
      className={withCssModulesClassNamesHandler('card__link', link.className)}
    >
      {link.text}
    </UniversalLinkContainer>
  ) : null;
};

CardLinks.defaultProps = {
  points: [],
  index: 0,
  isPointCarousel: false,
  links: [],
  type: '',
  isHero: false,
  shouldRenderAsLink: null,
};

CardLinks.propTypes = {
  points: PropTypes.arrayOf(PropTypes.shape(pointPropTypes)),
  index: PropTypes.number,
  isPointCarousel: PropTypes.bool,
  links: pointPropTypes.links,
  type: PropTypes.string,
  shouldRenderAsLink: PropTypes.bool,
  isHero: PropTypes.bool,
};

export default CardLinks;
